import { SegmentService } from "@main-services/segment.service";
import { Component, inject, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AccountService } from "@modules/account/services/account.service";
import { FiatService } from "@main-services/currency/fiat.service";
import { TradableListService } from "@main-services/currency/tradable_list.service";
import { TradableWalletListService } from "@main-services/wallet/tradable_wallet_list.service";
import { IndexWallet } from "@models/asset/index/index_wallet";
import { Index } from "@models/asset/index/index.model";
import { TradableWalletComponent } from "@modules/main/components/tradable-wallet.component";
import { IndexService } from "@main-services/currency/index.service";
import { IndexWalletService } from "@main-services/wallet/index_wallet.service";
import { Helper } from "@helpers/functions";
import { toCurrencyByFiatId } from "@helpers/tradable-convert";
import { IndexTransaction } from "@models/transaction";
import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { ModalService } from "@core-services/modal.service";
import { MasterdataService } from "@core-services/masterdata.service";
import { InfoService } from "@core-services/info.service";
import { TranslationService } from "@core-services/translation.service";
import { Observable } from "rxjs";
import { TradingOperationType } from "@gql/offer";
import { LaunchDarklyService, LD_FLAG } from "@core-services/launch-darkly/launch-darkly.service";
import { Tradable } from "@models/interfaces/tradable";
import { RudderstackService } from "@main-services/rudderstack.service";

@Component({
	templateUrl: "./index-wallet-transaction.component.html",
	styleUrls: ["./index-wallet-transaction.component.scss"],
	standalone: false
})
export class IndexWalletTransactionComponent
	extends TradableWalletComponent<IndexTransaction, Index, IndexWallet>
	implements OnInit
{
	public readonly transactionFilters: string[] = ["buy", "sell"];
	public readonly trackingBasePath: string = "/index-wallet";
	public readonly isAssetBackButton: boolean = true;
	public pendingTrades$: Observable<TradingOperationType[]>;
	private walletInitiated: boolean = false;
	private readonly launchDarkly = inject(LaunchDarklyService);
	public logosV4Active$ = this.launchDarkly.isActive$(LD_FLAG.ASSET_LOGOS_V4);
	public tradable: Tradable = null;

	public constructor(
		protected route: ActivatedRoute,
		protected infoService: InfoService,
		protected masterdataService: MasterdataService,
		protected modalService: ModalService,
		protected router: Router,
		protected currencyService: IndexService,
		protected tradableListService: TradableListService,
		protected accountService: AccountService,
		protected fiatService: FiatService,
		protected walletListService: TradableWalletListService,
		protected translationService: TranslationService,
		private apicallService: ApicallService,
		protected segmentService: SegmentService,
		protected rudderstackService: RudderstackService,
		protected activatedRoute: ActivatedRoute
	) {
		super(
			route,
			router,
			tradableListService,
			walletListService,
			translationService,
			accountService,
			activatedRoute
		);

		this.apicallService.get("wallet/" + this.walletId, new ApicallOption(IndexWallet)).subscribe(
			(a) => {
				this.walletService.updateItem(a[0]);
				this.walletInitiated = true;
			},
			(error) => Helper.handleError(error)
		);
	}

	public ngOnInit(): void {
		this.init("wallet/" + this.walletId + "/transactions");
		this.pendingTrades$ = this.walletService.getPendingTradesByAssetId(this.getCurrency().getPid());
		this.tradable = this.tradableListService.getItemById(this.getWallet().getCurrencyId());
		super.ngOnInit();
	}

	public get lang(): string {
		return this.translationService.getLanguage();
	}

	public showIndexChart(): boolean {
		return this.getWallet().getBalance() > 0 && this.walletInitiated;
	}

	protected get walletService(): IndexWalletService {
		return this.walletListService.getServiceForIndexInit();
	}

	public toFiat(c: number): number {
		return toCurrencyByFiatId(c, this.fiat); // Index balance is always returned in EUR, changing this to get correct FIAT
	}
}
